/** Маппинг статусов документов с их стилями */
export const DOCUMENT_STATUSES = {
  Действует: {
    class: 'active',
    bgColor: 'rgba(86, 202, 0, 0.16)',
    textColor: '#65CD50',
  },
  Отменен: {
    class: 'cancelled',
    bgColor: 'rgba(255, 76, 81, 0.16)',
    textColor: '#FF4C51',
  },
  Отменён: {
    class: 'cancelled',
    bgColor: 'rgba(255, 76, 81, 0.16)',
    textColor: '#FF4C51',
  },
  Черновик: {
    class: 'draft',
    bgColor: 'rgba(255, 180, 0, 0.16)',
    textColor: '#FFB400',
  },
  Архив: {
    class: 'archive',
    bgColor: 'rgba(138, 141, 147, 0.16)',
    textColor: '#8A8D93',
  },
} as const

export const DOCUMENT_EDITION_MAX_LENGTH = 12

export type DocumentStatusKey = keyof typeof DOCUMENT_STATUSES

const STATUS_SLUG_TO_LABEL: Record<string, string> = {
  draft: 'Черновик',
  active: 'Действует',
  cancelled: 'Отменен',
  canceled: 'Отменен',
  archive: 'Архив',
  archived: 'Архив',
}

const STATUS_LABEL_TO_SLUG: Record<string, string> = {
  Черновик: 'draft',
  Действует: 'active',
  Отменен: 'cancelled',
  Отменён: 'cancelled',
  Архив: 'archived',
}

/** Приводит статус из API к slug */
export const normalizeDocumentStatus = (status: unknown): string | null => {
  if (!status) {
    return null
  }

  if (typeof status === 'string') {
    if (status in STATUS_SLUG_TO_LABEL) {
      return status
    }

    return STATUS_LABEL_TO_SLUG[status] ?? status
  }

  if (typeof status === 'object') {
    const value = status as { slug?: string; name?: string }
    if (value.slug) {
      return normalizeDocumentStatus(value.slug)
    }
    if (value.name) {
      return normalizeDocumentStatus(value.name)
    }
  }

  return null
}

export const isActiveDocumentStatus = (status: unknown) =>
  normalizeDocumentStatus(status) === 'active'

export const isArchivedDocumentStatus = (status: unknown) => {
  const slug = normalizeDocumentStatus(status)

  return slug === 'archived' || slug === 'archive'
}

export const isDraftDocumentStatus = (status: unknown) =>
  normalizeDocumentStatus(status) === 'draft'

export type DocumentStatusTransition = 'active' | 'archived'

/** Следующий статус при смене через кнопку в карточке */
export const getDocumentStatusTransition = (status: unknown): DocumentStatusTransition | null => {
  if (isArchivedDocumentStatus(status)) {
    return 'active'
  }
  if (isActiveDocumentStatus(status)) {
    return 'archived'
  }
  if (isDraftDocumentStatus(status)) {
    return 'active'
  }

  return null
}

export const getDocumentStatusActionTooltip = (status: unknown): string => {
  if (isArchivedDocumentStatus(status)) {
    return 'Вернуть из архива'
  }
  if (isDraftDocumentStatus(status)) {
    return 'Сделать действующим'
  }

  return 'Архивировать'
}

export const getDocumentStatusLabel = (slug: string) =>
  STATUS_SLUG_TO_LABEL[slug] ?? slug

export const getDocumentStatusConfig = (status: string) => {
  const label = getDocumentStatusLabel(status)

  return DOCUMENT_STATUSES[label as DocumentStatusKey] || {
    class: 'unknown',
    bgColor: 'rgba(138, 141, 147, 0.16)',
    textColor: '#8A8D93',
  }
}
